<template>
  <div>
    <StatisticUserCardDialog ref="statisticUserCardDialog"></StatisticUserCardDialog>

    <template>
      <v-card flat>
        <p class="title text-center pt-2">Total overview</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-card-text>
          <p class="subtitle-1">
            <span>Total Users:</span>
            <span class="font-weight-bold">{{Object.keys(userData).length}}</span>
          </p>
          <p class="subtitle-1">
            <span>Total new users last 24h:</span>
            <span class="font-weight-bold">{{checkNewUsers.thisDay}}</span>
          </p>
          <p class="subtitle-1">
            <span>Total new users this week:</span>
            <span class="font-weight-bold">{{checkNewUsers.thisWeek}}</span>
          </p>
          <p class="subtitle-1">
            <span>Total new users this month:</span>
            <span class="font-weight-bold">{{checkNewUsers.thisMonth}}</span>
          </p>
          <p class="subtitle-1">
            <span>Total new users this year:</span>
            <span class="font-weight-bold">{{checkNewUsers.thisYear}}</span>
          </p>
        </v-card-text>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$refs.statisticUserCardDialog.openDialog()" color="error">More Info</v-btn>
        </v-card-actions>-->
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StatisticUserCardDialog from "@/pages/admin/components/statistic/users/dialog/statisticUserCardDialog";
export default {
  components: {
    StatisticUserCardDialog,
  },
  data() {
    return {
      formstatus: "",
      listcountries: [],
      users: [],
      userData: [],
      counting: 0,
    };
  },
  methods: {
    // Connect to the store.js, Getting all the reports
    ...mapActions(["GET_ALL_USER_DATA"]),

    //#1
    // Get the data made from the function made in store.js  GET_ALL_USER_DATA
    // Then use a spread operator to run through, and get Created key, and manipulate it into something we wish to use later.
    getAllUserData() {
      this.GET_ALL_USER_DATA().then((response) => {
        response = response.map((el) => {
          return {
            ...el,
            CreatedDays: this.$moment().diff(this.$moment(el.Created), "days"),
            Emails: el.Nickname,
          };
        });
        this.userData = response;
      });
    },
  },
  computed: {
    // Sort through the total users, and display the country with the latest users first
    // sortNewUsers(){
    //   return this.checkNewUsers.seeAllThisYear.slice().sort(function(a, b){
    //     return (a.CreatedDays < b.CreatedDays) ? 1 : -1;
    //   });
    // },

    //#2
    // Display the number of users within each country. Using .map   .reduce  .assign
    // Will take this an put it into an object.
    // showCountryPeople(){
    //   return this.userData.map(user => user.Country).reduce((accumulate,current) => Object.assign(accumulate,{[current]: (accumulate[current] | 0)+1}),{});
    // },

    //#3
    // Getting the object that contain country and userNumber, into an array
    // countryObjectIntoArray(){
    //   if (this.showCountryPeople) {
    //     return Object.keys(this.showCountryPeople).map((key) => {
    //       return {
    //         country: key,
    //         users: this.showCountryPeople[key]
    //       }
    //     });
    //   } else {
    //     return [];
    //   }
    // },

    /*
      This is a filter function.
      1. We have the array userData which contain information about ALL the users.
      2. In this we wish to display how many been created today, this week, this month and this year.
      3. 
    */
    checkNewUsers() {
      // Mapping over and getting all the created values
      let tmpUser = this.userData[0];
      // console.log(tmpUser)
      let thisDay = this.userData.filter((user) => user.CreatedDays === 0)
        .length;
      let thisWeek = this.userData.filter((user) => user.CreatedDays < 7)
        .length;
      let thisMonth = this.userData.filter((user) => user.CreatedDays < 31)
        .length;
      let thisYear = this.userData.filter((user) => user.CreatedDays < 365)
        .length;

      let seeAllThisYear = this.userData.filter(
        (user) => user.CreatedDays < 365
      );
      // Test to get out the specific object matching this
      let thisIsTest = this.userData.filter(
        (bannana) => bannana.Email == "bjornum"
      );

      return {
        thisDay,
        thisWeek,
        thisMonth,
        thisYear,
        thisIsTest,
        seeAllThisYear,
      };
    },
  },
  // When loading page, run the functions within mounted.
  mounted() {
    this.getAllUserData();
  },
};
</script>